import { render, staticRenderFns } from "./ModifyPallet.vue?vue&type=template&id=9e1b234a&"
import script from "./ModifyPallet.vue?vue&type=script&lang=js&"
export * from "./ModifyPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports